import {number, string} from "yup";

export interface DigitalniDopFormValues {
    Izolacija: number | null
    IzolacijaNaziv: string
    TipPanela: string | null
    KvalitetMaterijala: string | null
    IdentifikacijskaOznakaVProizvoda: string
    PodrucjePrimjene: string
    OznakaProizvoda: string
    Proizvodjac: string
    OvlasteniZastupnik: string
    SistemiOcjenjivanja: string
    UskladjeniStandard: string
    ObavjestajnoTijelo: string
    DokumentOEuOcjenjivanju: string
    matrix: {
        [itemId: number]: {
            [debljina: string]: string
        }
    }
}

export const DigitalniDopInitialValues: DigitalniDopFormValues = {
    Izolacija: null,
    IzolacijaNaziv: '',
    TipPanela:null,
    KvalitetMaterijala:null,
    IdentifikacijskaOznakaVProizvoda: '',
    PodrucjePrimjene: 'Metalom obložen termoizolacioni panel za upotrebu u građevinarstvu - Krovovi i oblaganje krovova (Metal faced thermal insulation panel for use in builings - Roofs and Roof cladding)',
    OznakaProizvoda: '',
    Proizvodjac: 'Alternativa d.o.o, Put Famosa 38, 71212 Hrasnica - Sarajevo, Bosna i Hercegovina',
    OvlasteniZastupnik: '/',
    SistemiOcjenjivanja: '',
    UskladjeniStandard: 'BAS EN 14509:2014 (EN 14509:2013)',
    ObavjestajnoTijelo: 'NB 1396: Fires S.R.O Slovakia (Reakcija na vatru) NB 1396: Fires S.R.O Slovakia (Reaction to fire)',
    DokumentOEuOcjenjivanju: 'Nije relevantno (Not relevant)',
    matrix: {}
}

export interface DigitalniDopItemValues {
    Id?: number
    Numeracija?: string
    Naziv: string
    NazivEng?: string | null
    NazivDe?: string | null
    NazivEs?: string | null
    NazivSl?: string | null
    Mjera?: string
    Standard?: string
}